export default "__VITE_ASSET__DieHQrfk__"